import editorTranslations from './editor/de';
import settingsTranslations from './settings/de';

export default {
    pages: {
        feedback: 'Feedback',
        disclaimer: 'Disclaimer',
        glossary: 'Hilfe',
    },
    home: {
        infoBanner:
            'In den kommenden Tagen werden wir das Login-Verfahren für werk-material.online umstellen. Bitte beachten Sie die E-Mail, die Sie kürzlich von uns erhalten haben.',
        title: 'Endlich verlässliche Kostenzahlen zu allen Baugattungen!',
        lead: 'Sie suchen stimmige Kennwerte und massgebliche Referenzdaten zu Bauten jeder Gattung? Bauen Sie auf die neue, webbasierte Datenbank von werk-material.online. Hier finden Sie umfassende Zahlen und griffige statistische Verfahren zum Schweizer Bauwesen – einfach, transparent und lückenlos.',
        segments: {
            data: {
                title: 'Erstklassige Daten als solides Fundament',
                lead: 'Rund um Methoden und Kennwerte setzt CRB die Standards für die Schweizer Bau- und Immobilienbranche. Gegliedert nach Objektarten und Baukostenplan (BKP, eBKP-H und eBKP-T) erlauben sie verlässliche Kostenkalkulationen, exakte Baubeschriebe und rationelle Prozesse in einem. Genauso hilfreich ist das regelmässig publizierte werkmaterial von werk, bauen + wohnen. Es vereint seit 1982 nützliche Daten zu allen Baugattungen aus einer konkurrenzlos langen Vergleichsperiode. Alle beschriebenen Objekte wurden nach strengen Qualitätskriterien der Redaktion ausgewählt. Auch deshalb gilt werk, bauen + wohnen als «Goldstandard» der Schweizer Baukultur.',
            },
            analysis: {
                title: 'Intelligente Analysetools und einzigartige Datenmenge',
                lead: 'Egal ob Sie ein Einzelobjekt intelligent analysieren oder übers Ganze informiert werden möchten: Die Kombination verschiedener Perspektiven auf die Zahlenwelt beleuchtet alle Baugattungen. Mit über 750 Datensätzen bietet werk-material.online eine einmalige Breite und Tiefe. Sie wurden von werk, bauen + wohnen mit Werten des Bundesamts für Statistik hinterlegt und mit weiteren Objekten der Datenbank von CRB ergänzt.',
            },
            architecture: {
                title: 'Schweizer Architekturgeschichte als Zugabe',
                lead: 'Zudem erlaubt werk-material.online einen einmaligen Blick auf die Architektur der Schweiz, weil das Portal trockene Daten mit ausführlich dokumentierten Objekten vereint. Der direkte Vergleich von Objekten zeigt, was es auf der Basis von Zahlen braucht, um in der Baukultur Standards zu setzen und Unterschiede zu machen.',
            },
        },
        'want-access': 'Möchten Sie Zugriff auf werk-material.online?',
        'register-here': 'Registrieren Sie sich gleich hier!',
        'register-buy': 'Registrieren & Kaufen',
    },
    register: {
        title: 'Herzlich Willkommen',
        'now-order-chargeable': 'Jetzt kostenpflichtig bestellen',
        'invoice-order': 'Bezahlung per Rechnung',
        'checking-and-delivery':
            'Nach Bestelleingang prüfen wir Ihre Daten und stellen Ihnen innert Wochenfrist eine Rechnung per Post zu. Die Verlängerung Ihres Abos erfolgt automatisch nach einem Jahr.',
        register: 'Registrieren',
        'login-info':
            'Sie brauchen ein Konto, um die ausgewählten Produkte zu kaufen. Bitte registrieren Sie sich und kommen Sie nach der Registration auf diese Seite zurück.<br/>Falls Sie schon ein Konto haben, so melden Sie sich bitte an. Sie werden danach auf diese Seite zurückgeführt.',
        order: {
            title: 'Produkt(e) auswählen',
            discount: {
                title: 'Rabatt',
                'new-customer': 'Neukunde',
                'member-crb': 'Mitglied CRB',
                'member-sia': 'Mitglied SIA',
                'subscriber-work-bauen-und-wohnen': 'Abonnent/in werk, bauen + wohnen',
                'discount-code': 'Rabatt-Code',
            },
            'order-summary': 'Bestellübersicht',
            'annual-fee': 'Jährliche Nutzungsgebühr',
            'applied-discount': '15% Rabatt',
            'net-total': 'Total netto',
            vat: '{{percentage}}% MwSt',
            total: 'Total',
            promotion: 'Jetzt von Promotion profitieren',
        },
        'data-collection': {
            dialog: {
                title: 'WICHTIGE HINWEIS FÜR DATENSAMMLUNG:',
                description: {
                    title: '4.2 Zusätzliche Bestimmungen für die Nutzung der CRB-Web-Applikationen im Zusammenhang mit Daten von Anwendern (AGB - CRB)',
                    content:
                        'CRB stellt registrierten Anwendern von einzelnen Web-Applikationen die Möglichkeit zur Verfügung, sich und/oder ihre Projekte und/oder Projektdaten CRB und/oder anderen registrierten Anwendern von CRB-Web-Applikationen anhand von auf den CRB-Web-Applikationen vorgegebenen Masken vorstellen zu können. Verschiedene CRB-Web-Applikationen stellen eine Kontakt- und Informationsplattform dar, welche es den registrierten Anwendern ermöglichen soll, Informationen über eigene Projekte zu verbreiten und Informationen über Projekte anderer Anwender zu erhalten sowie mit den anderen Anwendern in Kontakt zu treten und sich auszutauschen. Die Nutzung der CRB-Web-Applikationen setzt in der Regel eine Registrierung voraus. Bei der Registrierung kann der Anwender Angaben zu sich bzw. zu seinem Unternehmen und/oder seinen Projekten, teilweise einschliesslich Projektbeteiligten, machen, wobei die gemachten Angaben den tatsächlichen Gegebenheiten entsprechen und wahr sein müssen sowie die Veröffentlichung der Angaben im Einverständnis mit den Betroffenen und in Nachachtung der datenschutzrechtlichen Vorgaben erfolgen muss. CRB kann dafür keine Gewährleistung übernehmen und wird vom verantwortlichen Anwender, wenn Ansprüche gegen CRB geltend gemacht werden, vollumfänglich schad- und klaglos gehalten. CRB behält sich jedoch das Recht vor, unrichtige, unpassende, fehlerhafte und unwahre Angaben des Anwenders ohne Angabe von Gründen und ohne Information des Anwenders zu entfernen. Der gewählte Benutzername sowie das Passwort für den Zugang zu den CRB-Web-Applikationen sind geheim zu halten und dürfen insbesondere nicht registrierten Dritten nicht zugänglich gemacht werden. Die vom Anwender auf den CRB-Web-Applikationen gemachten Angaben über sich, sein Unternehmen sowie über seine Projekte können von CRB zur Errichtung und Zurverfügungstellung von weiteren Funktionen und/oder Angeboten uneingeschränkt verwendet werden. Insbesondere bei Webservices und Web-Applikationen die kostenlos genutzt werden können, werden die Angaben über die Projekte der Anwendenden wie, Daten, Modelle, Beschriebe, Klassifikationen usw., anonymisiert weiterverwertet und können von CRB nach Bedarf im eigenen Namen publiziert werden und/oder für die Zusammenstellung von Werten und/oder statistischen Auswertungen, die CRB im eigenen Namen publizieren kann, beigezogen. Ebenso können die von Anwender genannten Projektpartner von CRB eingeladen werden, sich ebenfalls auf den CRB-Web-Applikationen zu registrieren. Der Anwender darf, die von anderen Anwendern gemachten Angaben zu Projekten und Projektpartnern ausschliesslich zu Informations- und Kontaktzwecke nutzen. Jede weitergehende Verwendung der auf den CRB-Web-Applikationen verfügbaren Informationen und Daten ist nur mit schriftlicher vorgängiger Einwilligung von CRB gestattet.',
                },
                cancel: 'OK',
            },
        },
        userdata: {
            title: 'Benutzerdaten',
            email: 'E-Mail Adresse',
            password: 'Kennwort',
            'repeat-password': 'Kennwort wiederholen',
            'immediate-access': 'Sofortzugriff nach Registration',
            'after-order':
                'Nachdem wir Ihre Bestellung erhalten haben, stellen wir Ihnen umgehend die Zugangsdaten zu werk-material.online per E-Mail zu',
            'password-requirements': 'Das Passwort muss mindestens {{length}} Zeichen lang sein',
        },
        billing: {
            title: 'Rechnungsdaten',
            salutation: 'Anrede',
            company: 'Firma',
            firstname: 'Vorname',
            lastname: 'Nachname',
            phonenumber: 'Telefon',
            street: 'Strasse',
            postofficebox: 'Postfach',
            postcode: 'PLZ',
            city: 'Ort',
            country: 'Land',
        },
        'accept-terms': 'Ich akzeptiere die Allgemeinen Geschäftsbedingungen',
    },
    login: {
        title: 'Melden Sie sich an',
        'register-link': 'oder erstellen Sie ein Konto',
        'forgot-password': 'Kennwort vergessen?',
        'reset-password-instruction':
            'Geben Sie Ihre bei uns hinterlegte E-Mail-Adresse an, damit wir Ihnen einen Link zum zurücksetzen Ihres Kennworts senden können.',
    },
    'password-reset': {
        'forgot-password': 'Kennwort vergessen?',
    },
    'create-project': {
        project: 'Projekt erstellen',
        estimation: 'eBKP-H Kalkulator',
        name: 'Projektname',
        'cost-index': {
            date: 'Preisstand',
            'greater-region': 'Grossregion',
        },
        'submit-button': 'Erstellen',
        error: 'Aufgrund fehlender Preisdaten werden Projekte aus Lichtenstein nicht unterstützt.',
    },
    editor: editorTranslations,
    settings: settingsTranslations,
    feedback: {
        title: 'Feedback',
        'submit-feedback': 'Senden',
        'thank-you': 'Vielen Dank für Ihr Feedback.',
        personal: {
            title: 'Persönliche Informationen',
            salutation: 'Anrede',
            firstname: 'Vorname',
            lastname: 'Name',
            email: 'E-Mail',
        },
        report: {
            title: 'Feedback',
            topic: 'Themen',
            text: 'Text',
        },
    },
    customerService: {
        title: 'Kundendienst',
        salutation: 'Anrede',
        firstname: 'Vorname',
        lastname: 'Name',
        email: 'E-Mail',
        text: 'Text',
        'submit-customer-service-request': 'Senden',
        'thank-you': 'Vielen Dank für Ihre Nachricht, die wir schnellstmöglich bearbeiten.',
    },
    company: {
        'cooperation-partners': 'Kooperationspartner',
        'customer-service': 'Kundenservice',
    },
    account: {
        'change-password': {
            title: 'Kennwort ändern',
            instructions: 'Geben Sie ihr altes Kennwort ein und wählen sie ein Neues.',
            'current-password': 'Aktuelles Kennwort',
            'new-password': 'Neues Kennwort',
            'repeat-new-password': 'Neues Kennwort wiederholen',
            change: 'Ändern',
        },
    },
    salutation: {
        male: 'Herr',
        female: 'Frau',
    },
    navigation: {
        account: 'Account',
        'change-password': 'Kennwort ändern',
        order: 'Produkt(e) auswählen',
    },
    common: {
        yes: 'ja',
        no: 'nein',
        name: 'Name',
        user: 'Benutzer',
        username: 'Benutzername',
        'email-address': 'E-Mail-Adresse',
        password: 'Kennwort',
        login: 'Anmelden',
        logout: 'Abmelden',
        remember: 'Angemeldet bleiben',
        confirm: 'Bestätigen',
        submit: 'Senden',
        close: 'Schliessen',
        'processing-request': 'Bearbeitung Ihrer Anfrage. Dies kann mehrere Minuten dauern',
        'do-not-reload': 'Bitte laden Sie die Seite nicht neu und haben Sie etwas Geduld. Besten Dank.',
        'waiting-for-sync': 'Ihre Bestellung wird bearbeitet. Bitte haben Sie einen kurzen Moment Geduld.',
        'thank-you': 'Vielen Dank!',
        editor: 'Editor',
        ok: 'OK',
        cancel: 'Abbrechen',
        continue: 'Weiter',
        back: 'Zurück',
        add: 'Hinzufügen',
        edit: 'Bearbeiten',
        pagination: {
            page: 'Seite',
            next: 'Nächste',
            previous: 'Vorherige',
        },
    },
    errors: {
        'error-title': 'Ein Fehler ist aufgetreten',
        'login-data-wrong': 'Benutzername und Kennwort stimmen nicht überein.',
        'no-required-roles':
            'Es ist leider ein Fehler aufgetreten. Bitte melden Sie sich ab und wieder an. Falls dies nicht zielführend ist, kontaktieren Sie bitte CRB unter <a href="mailto:support@crb.ch">support@crb.ch</a>.',
        'service-unavailable': 'Der Server konnte nicht erreicht werden.',
        'incomplete-form': 'Das eingereichte Formular ist unvollständig, bitte überprüfen Sie es noch einmal.',
        'server-failed': 'Der Server kann die Anfrage momentan nicht beantworten. Versuchen Sie es später erneut.',
    },
    export: {
        language: 'Sprache',
        success: '{{count}} Projekt wurde erfolgreich exportiert',
        success_plural: '{{count}} Projekte wurden erfolgreich exportiert',
        failed: '{{count}} Projekt konnte nicht exportiert werden',
        failed_plural: '{{count}} Projekte konnten nicht exportiert werden',
    },
    import: {
        title: 'Projekte importieren',
        text: 'Excel Datein mit dem korrekten Format können hier importiert werden.',
        areaText: 'Hier klicken oder die Dateien auf diese Fläche draggen.',
        success: '{{count}} Projekt wurde erfolgreich importiert:',
        success_plural: '{{count}} Projekte wurden erfolgreich importiert:',
        failed: '{{count}} Projekt konnte nicht importiert werden:',
        failed_plural: '{{count}} Projekte konnten nicht importiert werden:',
        errors: {
            upload: {
                failed: 'Hochladen ist fehlgeschlagen',
            },
            import: {
                invalid: {
                    file: 'Die Datei entspricht nicht dem akzeptierten Format',
                    lang: 'Ungültige oder fehlende Sprache',
                    name: 'Fehlender Name',
                    costIndexDate: 'Ungültiges oder fehlendes Preisstand Datum',
                    greaterRegion: 'Ungültige oder fehlende Grossregion',
                    buildingClass: 'Ungültige oder fehlende Werkkategorie',
                },
            },
        },
    },
    userinfo: {
        userEmail: 'Email',
        userId: 'Benutzer-ID',
        copy: {
            click: 'Klicken um zu kopieren',
            clicked: 'Kopiert!',
        },
    },
    project: {
        transfer: {
            'dialog-title': 'Projekt transferieren',
            'dialog-title_plural': 'Projekte transferieren',
            content:
                'Geben Sie die ID des Empfänger ein und klicken Sie auf Transferieren.\n\nNach dem Transfer wird das Projekt nicht mehr in ihrer Projektliste angezeigt!',
            content_plural:
                'Geben Sie die ID des Empfänger ein und klicken Sie auf Transferieren.\n\nNach dem Transfer werden die Projekte nicht mehr in ihrer Projektliste angezeigt!',
            receiverId: 'Empfänger ID',
            cancel: 'Abbrechen',
            confirm: 'Transferieren',
        },
    },
    languages: {
        de: 'Deutsch',
        fr: 'Französisch',
        it: 'Italienisch',
        en: 'Englisch',
    },
};
